import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { client } from '../sanityClient';
import { urlFor } from '../sanityClient';
import SEO from '../components/SEO';
import './Venue.css';

function Venue() {
  const [venue, setVenue] = useState(null);

  useEffect(() => {
    client.fetch('*[_type == "venue"][0]').then(data => {
      if (data) setVenue(data);
    });
  }, []);

  const heroTitle = (venue && venue.heroTitle) || 'OUR VENUE';
  const heroSubtitle = (venue && venue.heroSubtitle) || '네 개의 공간, 하나의 특별한 날';
  const noticeTitle = (venue && venue.noticeTitle) || 'Season Preview';
  const noticeContent = (venue && venue.noticeContent) || '계절을 준비하는 동안의 모습입니다. 이 사진들은 완전히 꾸며진 비전을 보여줍니다.';
  const noticeDetail = (venue && venue.noticeDetail) || '상담을 예약하시면 실제 공간을 확인하시고, 당신의 결혼식 날짜에 맞춘 세팅을 계획하실 수 있습니다.';
  
  const defaultSpaces = [
    { name: '주차장', slug: 'parking', capacity: '15대', description: '손님들을 위한 편리한 주차 공간', order: 1 },
    { name: '정원', slug: 'garden', capacity: '50-80명', description: '페어리 라이트 아래 하얀 자작나무', order: 2 },
    { name: '1층 홀', slug: 'hall', capacity: '30-40명', description: '하얀 벽돌 벽, 친밀한 모임', order: 3 },
    { name: '2층 하우스', slug: 'house', capacity: '20-30명', description: '프렌치 창문, 아늑한 다이닝', order: 4 },
    { name: '신부 대기실', slug: 'bridal-suite', capacity: '프라이빗 공간', description: '신부를 위한 준비 공간', order: 5 },
    { name: '가족 라운지', slug: 'family-lounge', capacity: '프라이빗 공간', description: '부모님을 위한 조용한 휴식 공간', order: 6 },
  ];

  const spaces = (venue && venue.spaces && venue.spaces.length > 0) 
    ? venue.spaces.sort(function(a, b) { return (a.order || 0) - (b.order || 0); })
    : defaultSpaces;

  const infoHeading = (venue && venue.infoHeading) || '완전한 공간';
  const infoDescription = (venue && venue.infoDescription) || '주차부터 다이닝까지, 모든 디테일을 고려했습니다.\n공간을 자유롭게 조합해 당신만의 완벽한 날을 만드세요.';

  return (
    <div className="venue-page">
      <SEO
        title="공간 안내 | 정원·홀·하우스"
        description="가든포에트 홍대 공간 안내. 300평 유럽풍 정원, 1F 홀, 2F 하우스 - 세 가지 공간이 만드는 완벽한 하우스웨딩."
        path="/venue"
      />
      <section className="season-notice">
        <div className="container">
          <div className="notice-banner fade-in">
            <div className="notice-icon">📷</div>
            <div className="notice-content">
              <h3>{noticeTitle}</h3>
              <p>{noticeContent}</p>
              <p className="notice-detail">{noticeDetail}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="venue-hero">
        <div className="container">
          <div className="venue-hero-content fade-in">
            <h1>{heroTitle}</h1>
            <p className="hero-subtitle">{heroSubtitle}</p>
          </div>
        </div>
      </section>

      <section className="venue-spaces">
        <div className="container-wide">
          <div className="venue-grid">
            {spaces.map(function(space, i) {
              return (
                <Link key={i} to={'/venue/' + space.slug} className="venue-card fade-in">
                  <div className="venue-image">
                    {space.mainImage ? (
                      <img src={urlFor(space.mainImage).width(600).url()} alt={space.name} />
                    ) : (
                      <div className="image-placeholder">{space.name}</div>
                    )}
                  </div>
                  <div className="venue-info">
                    <h3>{space.name}</h3>
                    <p className="capacity">{space.capacity}</p>
                    <p>{space.description}</p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <section className="venue-info-section">
        <div className="container">
          <div className="info-content fade-in">
            <h2>{infoHeading}</h2>
            <p>
              {infoDescription.split('\n').map(function(line, i) {
                return <React.Fragment key={i}>{i > 0 && <br />}{line}</React.Fragment>;
              })}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Venue;
